// removed by extract-text-webpack-plugin
module.exports = {"logo":"_1wGP_SuNwDjVKdcDnUlU0P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar.less
// module id = 624
// module chunks = 0